import { colors } from 'theme'

export const defaultThemeStyles = {
    control: colors.water,
    controlText: colors.darkBlue,
    menuBorder: colors.blue,
    menuBackground: colors.white,
}
